_ = require('lodash')
moment = require('moment')

ScoreUploadHelper = ->
  createParams: (roundInfo, club, players) ->
    params =
      id: roundInfo.id
      started_hole: roundInfo.started_hole
      time_zone_offset: (new Date().getTimezoneOffset() * -1) * 60000
      play_date:
        if moment.isMoment(roundInfo.play_date)
          roundInfo.play_date.valueOf()
        else
          moment(roundInfo.play_date).valueOf()
      weather: roundInfo.weather
      club: _.merge _.omit(club, ["courses", "showRakutenId"]),
        ext_id: club.id
        loc: [
          club.lat,
          club.lng
        ]
      course: _.pick roundInfo.course, ['ext_id', 'name']
      tee: _.pick roundInfo.tee, ['ext_id', 'name']
      holes: roundInfo.holes
      players: players.map (p) ->
        p.scores = _.filter(p.scores, (s) -> s.shot_cnt?).map (sc) ->
          _.omit(sc, ['scoreOptions', 'shotCntColor'])
        if roundInfo.extra_9 or roundInfo.has_extra
          p.scores_extra = _.filter(p.scores_extra, (s) -> s.shot_cnt?).map (sc_extra) ->
            _.omit(sc_extra, ['scoreOptions', 'shotCntColor'])
        p
    if roundInfo.extra_9 || roundInfo.has_extra
      params_extra =
        course_extra: _.pick roundInfo.course_extra, ['ext_id', 'name']
        extra_9: true
        tee_extra: _.pick roundInfo.tee_extra, ['ext_id', 'name']
        holes_extra: roundInfo.holes_extra
      return Object.assign({}, params, params_extra)
    else
      return params


module.exports = ScoreUploadHelper



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/score-upload-helper-service.coffee